import { render, staticRenderFns } from "./create_payment.vue?vue&type=template&id=221d82c6&"
import script from "./create_payment.vue?vue&type=script&lang=js&"
export * from "./create_payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports